module.exports = __webpack_public_path__ + "img/figure01_sp.ecd13416.png";